import { apiClient } from '@/api/client'
import type { ApiSuccessResponse, PaginationMeta } from '@/types/api'

/** One hired application. Shared with the super admin hires page. */
export interface HiredCandidate {
  applicationId: number
  studentProfileId: number
  candidateName: string | null
  candidateEmail: string | null
  jobId: number
  jobTitle: string
  organizationId: number
  organizationName: string
  program: string
  programCode: string
  isPortal: boolean
  academicPhase: string | null
  appliedAt: string | null
  hiredAt: string
}

export const recruiterHiresApi = {
  list: async (params: { q?: string; page?: number; per_page?: number }) => {
    const { data } = await apiClient.get<
      ApiSuccessResponse<HiredCandidate[]> & { meta: PaginationMeta }
    >('/recruiter/hires', { params })
    return { hires: data.data, meta: data.meta }
  },
}
